// The trial banner (cutover milestone A): one line on the pages of a module still in its
// trial, from /api/me's `trials`. The shell draws it, so no module has to.

export interface TrialModule {
  name: string;
  title: string;
}

/** The trial module whose page this path is (`/<name>` or under it), or null. */
export function trialOf(path: string, trials: readonly TrialModule[]): TrialModule | null {
  const first = path.split('/')[1] ?? '';
  return trials.find((module) => module.name === first) ?? null;
}

/** A title as an owner: Bank's, Timers'. */
export function possessive(title: string): string {
  return `${title}${title.endsWith('s') ? "'" : "'s"}`;
}

/** The banner's words. */
export function trialBanner(title: string): string {
  return `Trial: ${possessive(title)} data here is replaced when it goes live.`;
}
